// The pump is told "move N cm of tank level" and runs N x seconds_per_cm (a measured
// 100 s/cm since firmware 1.2.2, owned by the firmware; the backend sends it as pump_config,
// and to the Radar Lab in its status limits). This default is only the fallback before that loads. These pure
// helpers turn that into what a person reads and validate the cm field.

// Fallbacks only - the backend sends the live values (pump_config; the Radar Lab's status limits), all from its ONE
// source, padihat-backend padihat_backend/pump_constants.py. Every fallback here derives from these few numbers, so a
// change there needs at most the matching edit here (and none at all while the backend answers).
const FALLBACK_SETTLE_SECONDS = 20; // pump_constants.WATER_SETTLE_SECONDS
const FALLBACK_PHOTO_WAIT_SECONDS = 60; // pump_constants.BEFORE_/AFTER_PHOTO_TIMEOUT_S
const FALLBACK_ENGINE_PHOTOS_SECONDS = 15; // pump_constants.ENGINE_PHOTOS_S

export const DEFAULT_PUMP_CONFIG = {
  seconds_per_cm: 100,
  min_cm_per_op: 0.1,
  max_cm_per_op: 5,
  settle_seconds: FALLBACK_SETTLE_SECONDS,
  // The worst-case allowance around every operation: before-photo wait + settle + after-photo wait.
  event_overhead_seconds: 2 * FALLBACK_PHOTO_WAIT_SECONDS + FALLBACK_SETTLE_SECONDS,
};

// The Radar Lab's per-step allowance for the engine's photos and settle (its limits.engine_overhead_s).
export const DEFAULT_LAB_ENGINE_OVERHEAD_SECONDS = FALLBACK_ENGINE_PHOTOS_SECONDS + FALLBACK_SETTLE_SECONDS;

export const pumpDurationSeconds = (cm, config = DEFAULT_PUMP_CONFIG) =>
  Math.round(cm * (config?.seconds_per_cm ?? DEFAULT_PUMP_CONFIG.seconds_per_cm));

// 12 -> "12 s", 120 -> "2 min", 150 -> "2 min 30 s"
export const formatPumpDuration = (seconds) => {
  const total = Math.max(0, Math.round(seconds));
  if (total < 60) return `${total} s`;
  const minutes = Math.floor(total / 60);
  const rest = total % 60;
  return rest === 0 ? `${minutes} min` : `${minutes} min ${rest} s`;
};

// Returns an error message, or null when the text is a usable cm value.
export const pumpCmError = (text, config = DEFAULT_PUMP_CONFIG) => {
  const min = config?.min_cm_per_op ?? DEFAULT_PUMP_CONFIG.min_cm_per_op;
  const max = config?.max_cm_per_op ?? DEFAULT_PUMP_CONFIG.max_cm_per_op;
  if (text === "" || text === null || text === undefined) return "Enter how many cm to pump.";
  const cm = Number(text);
  if (Number.isNaN(cm)) return "Distance (cm) must be a number.";
  if (cm < min - 1e-9 || cm > max + 1e-9) return `Distance must be between ${min} and ${max} cm.`;
  return null;
};
